/* Amon Atelier appointment tracking v1 — 2026-10-20.
 * Meety owns validation, submission and its success redirect. This script never
 * changes a booking. Contact values are kept only in a transient form cache;
 * only SHA-256 hashes enter short-lived session storage and Meta matching.
 * GA4 receives appointment metadata only. No extra PageView or commerce events.
 */
(function () {
  'use strict';
  if (window.__amonAppointmentTracking) return;
  var appointmentPath = '/products/appointment';
  var thanksPath = '/pages/appointment-confirmed';
  var path = location.pathname.replace(/\/$/, '');
  if (path !== appointmentPath && path !== thanksPath) return;
  window.__amonAppointmentTracking = true;
  var key = 'amon.appointment.v1';
  var ttl = 60 * 60 * 1000;
  var pixelId = '1186673230240044';
  var measurementId = 'G-2RZT86YEV3';
  var service = 'Private Appointment at Bank Hotel Stockholm';
  var variant = 'Default Title';
  var flow = null, revision = 0, sent = false, finishing = false, ownedGtag = false;
  var cache = new WeakMap();
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!p && p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function forget() {
    flow = null; revision++; cache = new WeakMap();
    try { sessionStorage.removeItem(key); } catch (_) {}
  }
  function read() {
    try {
      var item = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!item || !/^[A-Za-z0-9_-]{16,100}$/.test(item.flow_id) || !Number.isSafeInteger(item.created_at) || item.created_at > Date.now() + 30000 || Date.now() - item.created_at > ttl || (item.state !== 'pending' && item.state !== 'consumed')) {
        sessionStorage.removeItem(key); return null;
      }
      return item;
    } catch (_) { return null; }
  }
  function write(item) {
    try {
      sessionStorage.setItem(key, JSON.stringify(item));
      var saved = read();
      return saved && saved.flow_id === item.flow_id && saved.state === item.state;
    } catch (_) { return false; }
  }
  function sha256(value) {
    if (!value || !window.crypto || !window.crypto.subtle) return Promise.resolve('');
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buffer) {
      return Array.from(new Uint8Array(buffer)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    }).catch(function () { return ''; });
  }
  function email(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized) ? normalized : '';
  }
  function phone(value) {
    var normalized = String(value || '').trim().replace(/[\s().-]/g, '');
    if (normalized.indexOf('00') === 0) normalized = '+' + normalized.slice(2);
    return /^\+[1-9]\d{7,14}$/.test(normalized) ? normalized.slice(1) : '';
  }
  function hash(value) { return typeof value === 'string' && /^[a-f0-9]{64}$/.test(value) ? value : ''; }
  function normalized(field) { return field && field.type === 'tel' ? phone(field.value) : email(field && field.value); }
  function prepare(field) {
    if (!field || !allowed()) return Promise.resolve('');
    var value = normalized(field), prior = cache.get(field);
    if (prior && prior.value === value) return prior.promise;
    var entry = {value: value, hash: '', promise: null};
    entry.promise = sha256(value).then(function (result) {
      if (allowed() && cache.get(field) === entry) entry.hash = result;
      return result;
    });
    cache.set(field, entry); return entry.promise;
  }
  function cached(field) {
    if (!field) return '';
    var item = cache.get(field);
    return item && item.value === normalized(field) ? hash(item.hash) : '';
  }
  function fields(modal) {
    return {em: modal.querySelector('input[placeholder="Enter your email"]'), ph: modal.querySelector('input[type="tel"][placeholder="Enter your phone"]')};
  }
  function closestTarget(event) { return event.target && event.target.closest ? event.target : event.target && event.target.parentElement; }
  function newFlow() {
    if (!window.crypto || !window.crypto.randomUUID) return null;
    return {flow_id: window.crypto.randomUUID(), created_at: Date.now(), state: 'pending'};
  }
  if (path === appointmentPath) {
    document.addEventListener('input', function (event) {
      if (!allowed()) return;
      var target = closestTarget(event), modal = target && target.closest('.meety-modal-content');
      if (!modal || !modal.querySelector('#meety-button-confirm-schedule')) return;
      var f = fields(modal);
      if (target === f.em || target === f.ph) prepare(target);
    }, true);
    document.addEventListener('click', function (event) {
      var target = closestTarget(event);
      if (!target) return;
      if (target.closest('.meety-block-schedule-button')) { forget(); return; }
      var confirm = target.closest('#meety-button-confirm-schedule');
      if (!confirm || event.isTrusted !== true || confirm.classList.contains('meety-button-disabled')) return;
      if (!allowed()) { forget(); return; }
      var modal = confirm.closest('.meety-modal-content');
      if (!modal) return;
      var f = fields(modal);
      if (!f.em) return;
      var previous = read();
      if (!flow || Date.now() - flow.created_at > ttl || (previous && previous.flow_id === flow.flow_id && previous.state === 'consumed')) flow = newFlow();
      if (!flow) return;
      var attempt = flow, currentRevision = ++revision;
      var base = {flow_id: attempt.flow_id, created_at: attempt.created_at, state: 'pending'};
      var cachedEmail = cached(f.em), cachedPhone = cached(f.ph);
      if (cachedEmail) base.em_sha256 = cachedEmail;
      if (cachedPhone) base.ph_sha256 = cachedPhone;
      if (!write(base)) return;
      Promise.all([prepare(f.em), prepare(f.ph)]).then(function (values) {
        if (!allowed() || flow !== attempt || currentRevision !== revision) return;
        var stored = read();
        if (!stored || stored.state !== 'pending' || stored.flow_id !== attempt.flow_id) return;
        var enriched = {flow_id: attempt.flow_id, created_at: attempt.created_at, state: 'pending'};
        if (hash(values[0])) enriched.em_sha256 = values[0];
        if (hash(values[1])) enriched.ph_sha256 = values[1];
        write(enriched);
      }).catch(function () {});
    }, true);
  }
  function cleanUrl(value) {
    try { var url = new URL(value); return url.protocol === 'https:' ? url.origin + url.pathname : ''; } catch (_) { return ''; }
  }
  function fromAppointment() {
    try { var ref = new URL(document.referrer); return ref.origin === location.origin && ref.pathname.replace(/\/$/, '') === appointmentPath; } catch (_) { return false; }
  }
  function iso(value) {
    if (typeof value !== 'string') return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
    if (!m) return null;
    var year = +m[1], month = +m[2], day = +m[3];
    var zone = m[8] === 'Z' ? null : /^([+-])(\d{2}):(\d{2})$/.exec(m[8]);
    if (year < 2020 || year > 2100 || month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate() || +m[4] > 23 || +m[5] > 59 || +m[6] > 59 || (zone && (+zone[2] > 14 || +zone[3] > 59 || (+zone[2] === 14 && +zone[3] !== 0)))) return null;
    var time = Date.parse(value);
    return Number.isFinite(time) ? {time: time, value: new Date(time).toISOString()} : null;
  }
  function appointmentTimes() {
    try {
      var query = new URL(location.href).searchParams;
      if (query.getAll('meety_service').length !== 1 || query.get('meety_service') !== service || query.getAll('meety_variant').length !== 1 || query.get('meety_variant') !== variant || query.getAll('meety_timeslot').length !== 1) return null;
      var match = /^meety_from_time=([^&]+)&meety_to_time=?([^&]+)$/.exec(query.get('meety_timeslot') || '');
      if (!match) return null;
      var start = iso(match[1]), end = iso(match[2]);
      if (!start || !end || end.time <= start.time || end.time - start.time > 24 * 60 * 60 * 1000) return null;
      return {appointment_start: start.value, appointment_end: end.value, appointment_timezone: 'Europe/Stockholm'};
    } catch (_) { return null; }
  }
  function script(src) {
    return new Promise(function (resolve) {
      var element = document.createElement('script');
      element.async = true; element.src = src;
      element.onload = function () { resolve(true); };
      element.onerror = function () { resolve(false); };
      document.head.appendChild(element);
    });
  }
  function sendMeta(item, metadata) {
    var ready;
    if (window.fbq && window.fbq.callMethod) ready = Promise.resolve(true);
    else {
      if (!window.fbq) {
        var fbq = function () { if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments); else fbq.queue.push(arguments); };
        fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
        window.fbq = fbq;
        if (!window._fbq) window._fbq = fbq;
      }
      ready = script('https://connect.facebook.net/en_US/fbevents.js');
    }
    return ready.then(function (loaded) {
      if (!loaded || !allowed()) return;
      var data = {};
      if (hash(item.em_sha256)) data.em = item.em_sha256;
      if (hash(item.ph_sha256)) data.ph = item.ph_sha256;
      window.fbq('set', 'autoConfig', false, pixelId);
      window.fbq('consent', 'grant');
      window.fbq('init', pixelId, data);
      window.fbq('trackSingle', pixelId, 'Schedule', Object.assign({content_name: service, content_category: 'Appointment', booking_platform: 'Meety'}, metadata), {eventID: 'amon_schedule_' + item.flow_id});
    }).catch(function () {});
  }
  function sendGA(metadata) {
    var ready;
    if (typeof window.gtag === 'function') ready = Promise.resolve(true);
    else {
      ownedGtag = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', {analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'});
      ready = script('https://www.googletagmanager.com/gtag/js?id=' + measurementId);
    }
    return ready.then(function (loaded) {
      if (!loaded || !allowed()) return;
      if (ownedGtag) { window.gtag('consent', 'update', {analytics_storage: 'granted'}); window.gtag('js', new Date()); }
      window.gtag('config', measurementId, {send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false, page_location: cleanUrl(location.href), page_referrer: cleanUrl(document.referrer)});
      window.gtag('event', 'appointment_booked', Object.assign({send_to: measurementId, appointment_service: 'private_appointment_bank_hotel', booking_platform: 'Meety', page_location: cleanUrl(location.href), page_referrer: cleanUrl(document.referrer)}, metadata));
    }).catch(function () {});
  }
  function finish() {
    if (path !== thanksPath || sent || finishing || !allowed() || !fromAppointment()) return;
    var metadata = appointmentTimes();
    if (!metadata) return;
    finishing = true;
    var item = read();
    if (!item || item.state !== 'pending') { finishing = false; return; }
    if (!write({flow_id: item.flow_id, created_at: item.created_at, state: 'consumed'})) { finishing = false; return; }
    sent = true;
    try { window.history.replaceState(window.history.state, '', cleanUrl(location.href)); } catch (_) {}
    sendMeta(item, metadata); sendGA(metadata);
    flow = null; cache = new WeakMap();
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) {
      forget();
      if (window.fbq) window.fbq('consent', 'revoke');
      if (ownedGtag && window.gtag) window.gtag('consent', 'update', {analytics_storage: 'denied'});
    } else finish();
  });
  window.addEventListener('pagehide', function () { flow = null; revision++; cache = new WeakMap(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { flow = null; revision++; cache = new WeakMap(); } });
  if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) { if (!error && allowed()) finish(); else forget(); });
  }
  if (allowed()) finish();
  else if (window.Shopify && window.Shopify.customerPrivacy) forget();
}());
